module.exports = __webpack_public_path__ + "img/mobile-background.5cca416f.webp";